// extracted by mini-css-extract-plugin
module.exports = {"marketListContainer":"MobileMarketList_marketListContainer__Aafxs"};